/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Traditional_ChineseInputs */

const en_traditional_chinese = /** @type {(inputs: Traditional_ChineseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traditional Chinese`)
};

const fr_traditional_chinese = /** @type {(inputs: Traditional_ChineseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chinois traditionnel`)
};

const de_traditional_chinese = /** @type {(inputs: Traditional_ChineseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traditionelles Chinesisch`)
};

const it_traditional_chinese = /** @type {(inputs: Traditional_ChineseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cinese tradizionale`)
};

const ru_traditional_chinese = /** @type {(inputs: Traditional_ChineseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Традиционный китайский`)
};

const es_traditional_chinese = /** @type {(inputs: Traditional_ChineseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chino tradicional`)
};

const zh_cn2_traditional_chinese = /** @type {(inputs: Traditional_ChineseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`传统中文`)
};

const ja_traditional_chinese = /** @type {(inputs: Traditional_ChineseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`繁体字中国語`)
};

const hi_traditional_chinese = /** @type {(inputs: Traditional_ChineseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परंपरागत चीनी`)
};

const pt_pt2_traditional_chinese = /** @type {(inputs: Traditional_ChineseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chinês tradicional`)
};

/**
* | output |
* | --- |
* | "Traditional Chinese" |
*
* @param {Traditional_ChineseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const traditional_chinese = /** @type {((inputs?: Traditional_ChineseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Traditional_ChineseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_traditional_chinese(inputs)
	if (locale === "de") return de_traditional_chinese(inputs)
	if (locale === "it") return it_traditional_chinese(inputs)
	if (locale === "ru") return ru_traditional_chinese(inputs)
	if (locale === "es") return es_traditional_chinese(inputs)
	if (locale === "zh-CN") return zh_cn2_traditional_chinese(inputs)
	if (locale === "ja") return ja_traditional_chinese(inputs)
	if (locale === "hi") return hi_traditional_chinese(inputs)
	if (locale === "pt-PT") return pt_pt2_traditional_chinese(inputs)
	return en_traditional_chinese(inputs)
});